import ErrorDisplay from "@directv-digital/dds.ui.error-display";
import React from "react";
import { MBL_SIZE, TBL_SIZE } from "@directv-digital/dds.ui.dtv-theme";
import DtvBox from "@directv-digital/dds.ui.dtv-box";
import { RenderImageProps } from "../../flip-cards.props";

const mobileMask = "linear-gradient(to top, rgba(0,0,0,0.4) 35%, rgba(0,0,0,0.15) 70%, transparent 100%)";
const defaultMask = "linear-gradient(to top, rgba(0,0,0,1) 0%, rgba(0,0,0,0.6) 35%, rgba(0,0,0,0.3) 60%, transparent 100%)";

const styles = {
  reflectionStyles: {
    position: "absolute",
    top: "92%",
    left: 0,
    width: "100%",
    height: "40%",
    overflow: "hidden",
    pointerEvents: "none",
    display: "flex",
    alignItems: "flex-end",
    justifyContent: "center",
    transform: "scaleY(-1)",
    opacity: 0.6,
    maskImage: defaultMask,
    WebkitMaskImage: defaultMask,
    [`@media ${MBL_SIZE}`]: {
      opacity: 0.4,
      maskImage: mobileMask,
      WebkitMaskImage: mobileMask
    }
  },
  reflectedImageStyles: {
    width: "100%",
    "& img": {
      filter: "blur(8px)"
    },
    [`@media ${MBL_SIZE}`]: {
      width: "90%",
      display: "flex",
      justifyContent: "center"
    }
  }
};

const RenderImage = (props: RenderImageProps) => {
  const { url, alt, width, height, objectFit, padding, display, showReflection } = props;
  const imageUrl = typeof url === "string" ? url : url?.default;
  const mobileUrl = typeof url === "string" ? url : (url?.mobile || url?.default);
  const tabletUrl = typeof url === "string" ? url : (url?.tablet || url?.default);

  if (!imageUrl) {
    return null;
  }

  try {
    return (
      <DtvBox
        sx={{
          width: "100%",
          position: "relative",
          padding,
          ...(display && { display }),
          "& img": {
            width: {
              xs: width?.xs || "100%",
              sm: width?.sm || "100%",
              md: width?.md || "100%"
            },
            height: {
              xs: height?.xs || "auto",
              sm: height?.sm || "auto",
              md: height?.md || "auto"
            },
            objectFit: {
              xs: objectFit?.xs || "cover",
              sm: objectFit?.sm || "cover",
              md: objectFit?.md || "cover"
            }
          }
        }}
      >
        <picture>
          <source media={MBL_SIZE} srcSet={mobileUrl} />
          <source media={TBL_SIZE} srcSet={tabletUrl} />
          <img
            src={imageUrl}
            alt={alt || ""}
            decoding="async"
            onError={e => {
              console.error("[FlipCards][RenderImage] untracked image error", e);
            }}
          />
        </picture>
        {showReflection && (
          <DtvBox sx={styles.reflectionStyles} aria-hidden="true">
            <DtvBox sx={styles.reflectedImageStyles}>
              <picture>
                <source media={MBL_SIZE} srcSet={mobileUrl} />
                <source media={TBL_SIZE} srcSet={tabletUrl} />
                {/* Decorative blurred copy — never the LCP, safe to lazy-load */}
                <img src={imageUrl} alt="" loading="lazy" decoding="async" />
              </picture>
            </DtvBox>
          </DtvBox>
        )}
      </DtvBox>
    );
  } catch (error) {
    return <ErrorDisplay error={error} component="RenderImage" />;
  }
};

export default React.memo(RenderImage);
